export const state = {
  discussions: {},
  localDiscussions: {}
}
